import { css, SerializedStyles } from '@emotion/core'
import * as React from 'react'

import SvgIcon from './SvgIcon'

interface PaginationBlockProps {
  circlesQuantity: number
  currentSelection: number
  setCurrentSelection: React.Dispatch<React.SetStateAction<number>>
  className?: string
  color?: string
  displayArrowsOnSmallOnly?: boolean
  cssStyles?: SerializedStyles
}

const PaginationBlock: React.FunctionComponent<PaginationBlockProps> = ({
  circlesQuantity,
  currentSelection,
  setCurrentSelection,
  className,
  color = '#318eff',
  displayArrowsOnSmallOnly = false,
  cssStyles,
}) => {
  if (circlesQuantity < 2) {
    return null
  }

  const circles = []
  for (let i = 0; i < circlesQuantity; i++) {
    circles.push(
      <SvgIcon
        key={`pagination-circle-${i}`}
        className="opacity-on-hover"
        src="abstract/circle"
        css={circleStyle(i === currentSelection, color)}
        onClick={() => setCurrentSelection(i)}
      />
    )
  }

  return (
    <div className={className} css={[containerStyle(color), cssStyles]}>
      <SvgIcon
        className={`opacity-on-hover ${displayArrowsOnSmallOnly && 'hide-on-medium-large-desktop'}`}
        src="abstract/arrow-left"
        onClick={() =>
          currentSelection === 0 ? setCurrentSelection(circlesQuantity - 1) : setCurrentSelection(currentSelection - 1)
        }
        css={arrowStyle}
      />
      <div css={circlesContainerStyle}>{circles}</div>
      <SvgIcon
        className={`opacity-on-hover ${displayArrowsOnSmallOnly && 'hide-on-medium-large-desktop'}`}
        src="abstract/arrow-right"
        onClick={() => setCurrentSelection((currentSelection + 1) % circlesQuantity)}
        css={arrowStyle}
      />
    </div>
  )
}

export default PaginationBlock

const containerStyle = (color: string) => css`
  margin: 1.5rem auto;
  display: flex;
  column-gap: 2.25rem;
  justify-content: center;

  svg {
    cursor: pointer;

    circle,
    path {
      stroke: ${color};
    }
  }
`

const circlesContainerStyle = css`
  display: flex;
  column-gap: 1rem;
`

const circleStyle = (currentSelection: boolean, color: string) => css`
  // better UX (clickable area is larger than the circle)
  padding: 0.25rem;
  margin: -0.25rem;
  ${currentSelection && `fill: ${color}`};
`

const arrowStyle = css`
  // better UX (clickable area is larger than the circle)
  padding: 0.5rem;
  margin: -0.5rem;
`
